/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} So_Credit_PendingInputs */

const en_so_credit_pending = /** @type {(inputs: So_Credit_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit not checked`)
};

/**
* | output |
* | --- |
* | "Credit not checked" |
*
* @param {So_Credit_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const so_credit_pending = /** @type {((inputs?: So_Credit_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<So_Credit_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_so_credit_pending(inputs)
});